const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Audio player events (dispatched as native CustomEvents on `document` by
// audio-player.js — see that file). Listed here as the single registry of names.
const PLAYER_EVENTS = {
  play: 'player:play', // fired by play buttons; { album, startIndex }
  track: 'player:track', // current track changed; { album, track }
  state: 'player:state', // play/pause/volume/queue-ends changed
  progress: 'player:progress', // per-frame { position, duration }
};
